import React from "react";
import createReactClass from "create-react-class";


export default createReactClass({
  displayName: "Root",
  getInitialState() {
    return {
      photoUrl: "",
      // 「⋮」メニューを開いているか（見た目のみ）
      isMenuOpen: false,
    };
  },
  componentDidMount() {
    var url = this.props.album["top_photo_url"]
      ? this.props.album["top_photo_url"]
      : "/images/ja2/img_noimage.gif";
    this.setState({
      photoUrl: url,
    });
  },
  onError() {
    this.setState({
      photoUrl: "/images/ja2/img_noimage.gif",
    });
  },
  openMenu() {
    this.setState({ isMenuOpen: true });
  },
  closeMenu() {
    this.setState({ isMenuOpen: false });
  },
  // 削除は、これまでの「×」と同じ処理（確認のモーダル → 削除）を呼ぶ
  handleMenuDelete() {
    this.closeMenu();
    this.props.albumSelected(this.props.albumId);
  },
  handleAlbumClicked() {
    window.location.href =
      "/circle/" + this.props.circleId + "/album/" + this.props.albumId;
  },
  render() {
    var albumTitle = this.props.album["album_title"]
      ? this.props.album["album_title"]
      : "無題のアルバム";
    var publicType = this.props.publicTypeData[this.props.album.public_type];
    // 写真の枚数。写真の上に載せるとちゃちく見えたので、タイトルの下に置く（デザイナー判断）。
    // マークは0件表示と同じ写真のマーク
    var count = (
      <span className="alb-card__count">
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><circle cx="8.5" cy="8.5" r="1.5" /><path d="m21 15-5-5L5 21" /></svg>
        {this.props.album["photo_count"]}
        <span className="alb-card__sr">枚</span>
      </span>
    );
    // 2026: 承認ずみのサークルのイベント一覧（画面68）のカードの形（白・細い枠線・角丸14px）
    return (
      <li
        className={"alb-card" + (this.state.isMenuOpen ? " is-menu-open" : "")}
      >
        <div className="alb-card__cover">
          <img
            className="alb-card__img"
            src={this.state.photoUrl}
            alt=""
            onClick={this.handleAlbumClicked}
            onError={this.onError}
          />
          {/* 公開範囲のタグは「サークル内限定」のときだけ、写真の右上に出す（公開はふつうの状態なので印を付けない） */}
          {publicType && this.props.album.public_type != 4 ? (
            <span className="alb-card__tag alb-card__tag--onphoto">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></svg>
              {publicType.name}
            </span>
          ) : (
            ""
          )}
        </div>
        <div className="alb-card__body">
          <div className="alb-card__row">
            <a className="alb-card__link" onClick={this.handleAlbumClicked}>
              <p className="alb-card__title">{albumTitle}</p>
              <p className="alb-card__meta">{count}</p>
            </a>
            {/* 「⋮」はタイトルの右（メンバー一覧・画面73の行の右端と同じ置き方） */}
            <div className="alb-card__side">
              {this.props.isMember ? (
                <button
                  type="button"
                  className="alb-card__kebab"
                  aria-label="アルバムのメニュー"
                  onClick={this.openMenu}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="5" r="2" /><circle cx="12" cy="12" r="2" /><circle cx="12" cy="19" r="2" /></svg>
                </button>
              ) : (
                ""
              )}
              {this.state.isMenuOpen ? (
                // 「⋮」のすぐ下に小さく開くメニュー。背景は暗くしない（選ぶだけなので）。
                // 外を押すと閉じる（透明な面で受ける）
                <React.Fragment>
                  <div className="alb-menu__backdrop" onClick={this.closeMenu} />
                  <div className="alb-menu" role="menu" aria-label="アルバムのメニュー">
                  <ul className="alb-menu__list">
                    {/* 編集はアルバムの中（画面62）の「編集」で行うので、そこへ移動する */}
                    <li>
                      <button type="button" className="alb-menu__item" onClick={this.handleAlbumClicked}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" /></svg>
                        編集
                      </button>
                    </li>
                    <li>
                      <button type="button" className="alb-menu__item alb-menu__item--danger" onClick={this.handleMenuDelete}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M3 6h18" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" /><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg>
                        削除
                      </button>
                    </li>
                  </ul>
                  </div>
                </React.Fragment>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </li>
    );
  },
});
